import { render, staticRenderFns } from "./CarouselPrincipal.vue?vue&type=template&id=da8ed486"
import script from "./CarouselPrincipal.vue?vue&type=script&lang=js"
export * from "./CarouselPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports